// extracted by mini-css-extract-plugin
export default {"Virtual":"Virtual_Virtual__2zEzh","left":"Virtual_left__E6aKj","wrapper":"Virtual_wrapper__y7Oqu"};